// extracted by mini-css-extract-plugin
export default {"alertCard":"AlertCard_alertCard__BQFaj","alertActions":"AlertCard_alertActions__EYQYL","date":"AlertCard_date__+W8D3","alertIcons":"AlertCard_alertIcons__LuEP9"};